(function() {
    'use strict';

    angular.module('wamasysApp').factory('Mfa', Mfa);
    Mfa.$inject = ['$http'];

    function Mfa($http) {
        // Les secrets d'enrôlement restent en mémoire ; aucun stockage local ni journalisation.
        return {
            status: function() { return $http.get('api/account/mfa').then(body); },
            setup: function(proof) { return $http.post('api/account/mfa/setup', proof).then(body); },
            activate: function(proof) { return $http.post('api/account/mfa/activate', proof).then(body); },
            disable: function(proof) { return $http.post('api/account/mfa/disable', proof).then(body); },
            managedStatus: function(login) { return $http.get(userUrl(login)).then(body); },
            disableForUser: function(login) { return $http.delete(userUrl(login)).then(body); }
        };

        function userUrl(login) { return 'api/users/' + encodeURIComponent(login) + '/mfa'; }
        function body(response) { return response.data; }
    }
})();
